import React from 'react';
import { View, Image, StyleSheet, TouchableOpacity } from 'react-native';
import { PnmacText } from 'pnmac-universal-components';
import { textStyle } from '../v2/theme';
export default function PnmacOfferBlogPostCard(props) {
  return /*#__PURE__*/React.createElement(View, {
    style: styles.mainContainer
  }, /*#__PURE__*/React.createElement(TouchableOpacity, {
    onPress: function () {
      if (props.onPress) {
        props.onPress();
      }
    }
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(View, {
    style: styles.imageContainer
  }, /*#__PURE__*/React.createElement(Image, {
    resizeMode: "cover",
    style: styles.postImage,
    source: props.item.post_image_url.length <= 0 ? require("../assets/defaultAdBgImage.png") : {
      uri: props.item.post_image_url
    }
  })), /*#__PURE__*/React.createElement(View, {
    style: styles.postContentContainer
  }, /*#__PURE__*/React.createElement(PnmacText, {
    style: [textStyle.adTextTag, {
      marginTop: 0
    }]
  }, props.item.post_breadcrumb_title), /*#__PURE__*/React.createElement(PnmacText, {
    style: [textStyle.adTextTitle, {
      color: props.customTitleTextColor
    }]
  }, props.item.post_title), /*#__PURE__*/React.createElement(PnmacText, {
    numberOfLines: 2,
    style: [textStyle.adText, {
      marginBottom: 10
    }]
  }, props.item.post_summary)))));
}
;
var styles = StyleSheet.create({
  mainContainer: {
    width: 371,
    height: 295,
    backgroundColor: "#FFFFFF",
    borderRadius: 5,
    shadowOffset: {
      width: 0,
      height: 3
    },
    shadowOpacity: 0.1,
    shadowColor: "#777777",
    shadowRadius: 5,
    elevation: 1
  },
  imageContainer: {
    height: 140,
    width: "100%",
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5
  },
  postImage: {
    width: "100%",
    height: 120,
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5
  },
  postContentContainer: {
    padding: 15,
    justifyContent: "space-between"
  }
});